import { render, staticRenderFns } from "./news-management.vue?vue&type=template&id=533ded67&scoped=true"
import script from "./news-management.vue?vue&type=script&lang=js"
export * from "./news-management.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./news-management.vue?vue&type=style&index=1&id=533ded67&prod&lang=stylus&scoped=true"
import style2 from "./news-management.vue?vue&type=style&index=2&id=533ded67&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533ded67",
  null
  
)

export default component.exports